import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { iif } from 'rxjs';

@Component({
  selector: 'app-fiters',
  templateUrl: './fiters.component.html',
  styleUrls: ['./fiters.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class FitersComponent implements OnInit {
  data: any = [];
  user: any = [];
  selection: any = [];
  fiterItems: boolean;
  fliterValues: boolean;
  s: any;
  value: any;
  sss: string;
  length: any;
  filterMap = new Map<any, any>();
  totalCount: any;
  key: string;
  maxPrice: any=0;
  minimumPrice: any=0;
  minPriceControl = new UntypedFormControl(0);
  maxPriceControl = new UntypedFormControl(0);
  checked: any=[];
  keyChecked: any=[];
  constructor(
    private dialogRef: MatDialogRef<FitersComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialog: MatDialog
  ) {
    this.data = data

    

    this.sss = "Price";
  }
  series: any = [];
  ngOnInit() {
    this.minimumPrice=this.data.min
    this.maxPrice=this.data.max
   
    this.minPriceControl.patchValue(this.data.min);
    this.maxPriceControl.patchValue(this.data.max)
    this.key="Price"
    
   if(this.data.checked.length>0){
     this.selection=this.data.checked;
     this.filterMap=this.data.map;
     this.length=this.data.checked.length
     this.keyChecked=this.data.keyChecked;

  
   }else{
    this.selection=[];
    this.keyChecked=[];
    this.length=0;
   }
   this.filterMap=this.data.map;
   if( this.filterMap.size>0){
   
    if(this.filterMap.get("price")!== undefined){

      let value=this.filterMap.get("price").split("#");
      this.minPriceControl.patchValue(value[0]);
      this.maxPriceControl.patchValue(value[1])
    }
   }
   this.totalCount=this.data.total;

  }
  searchText: any;
  subList(s) {
    
    this.sss = s;



  }
  condition: string;

  filterColumn(event, id, i,key) {
    this.condition = null;
    
    this.s = this.sss + '_s';
    if (event.checked) {
      if (this.filterMap.get(this.s) == undefined) {
        this.filterMap.set(this.s, event.source.value);
      } else {
        
        this[this.s] = this.filterMap.get(this.s) + '#' + event.source.value;

        this.filterMap.set(this.s, this[this.s]);
      }
      
      //  this.filterByAttribute();
      this.selection.push(key+event.source.value);

      this.keyChecked.push(key);
      
    }
    else {

      this.condition = this.filterMap.get(this.s).replace(event.source.value, "")
      
      let index = this.condition.length - 1;
      
      if (this.condition[index] == '#') {
        this.condition = this.condition.substring(0, index);
        
        this.filterMap.set(this.s, this.condition);
      } else if (this.condition.length == 0) {
        
        this.filterMap.delete(this.s)
        // this.productsByCategory();
      }
      else {
        this.filterMap.set(this.s, this.condition);
      }
  
      if (this.filterMap.get(this.s) != undefined ) {
        
        if( this.filterMap.get(this.s).charAt(0) == '#'){
        this.condition = this.filterMap.get(this.s).slice(1);
        this.filterMap.set(this.s, this.condition);
        }
      }
      var indexCheckValue = this.selection.indexOf(key+event.source.value);

      if (indexCheckValue > -1) {
        this.selection.splice(indexCheckValue, 1);
      }

      var indexCheckKey = this.keyChecked.indexOf(key);

      this.keyChecked.splice(indexCheckKey, 1);

    }
    
    
  }

  rangeChanged(code ): void {
   
    if(this.maxPriceControl.value==''){
      this.maxPriceControl.patchValue(this.data.max)
    }


    if(this.maxPriceControl.value=='.'){
      this.maxPriceControl.patchValue(0)
    }
    
    if(this.minPriceControl.value==''){
      this.minPriceControl.patchValue(this.data.min)
    }
      if( this.minPriceControl.value!=this.minimumPrice || this.maxPriceControl.value!=this.maxPrice){
        let value= parseFloat(this.minPriceControl.value);
        let value1= parseFloat(this.maxPriceControl.value);
          this.filterMap.set(
            "price",
            value.toFixed() + "#" + value1.toFixed()
          );
        }else{
          this.filterMap.delete("price");
        }
    

}

  back() {
    this.dialogRef.close({event:'close'})
  }

  apply(){
    this.dialogRef.close({event:'update',data:this.filterMap,checked:this.selection,keyChecked:this.keyChecked})
  }

  checkContains(code ){
    let value= this[code].value;
      
    value=value.replace(/[^0-9]/g, '')
 
    this[code].patchValue(value)
  }
}
